import React, { Component } from 'react'
import { Box, Grid, SelectChangeEvent, TextField, Typography } from "@mui/material";
import IbssSvgIcon from '../../../../Components/Icons/SvgIcon/IbssSvgIcon';
import { appContext } from '../../../../AppContext';
import { Icons } from '../../../../Common/AllsvgIcons';
import IbssSwitchLabel from '../../../../Components/Inputs/Switch/IbssSwitchLabel';
import IbssFormControl from '../../../../Components/Forms/FormControl/IbssFormControl';
import IbssTextField from '../../../../Components/Inputs/TextField/IbssTextField';
import IbssInputDropDown from '../../../../Components/Inputs/SelectList/IbssInputDropDown';
import MediaSelector, { IFile } from '../../../../Components/DialogLaunchers/MediaSelector/MediaSelector';
import { IFileType, IFilterOptions, IFilterOptionsNumber } from './EditAdvancedSpace.tsx';
import IbssPageHeader from '../../../../Components/Headings/PageHeading/IbssPageHeader';


export default class SpaceConfiguration extends Component<ISpaceConfigurationProps> 
{
  private get labels() { return appContext().labels; }

  render(): JSX.Element
  {
    const {onSpaceNameLabelChange,spaceNameError,spaceNameLabelError,spaceIdError,selectedBuildingOptionError,bookingPolicyOptionError,imageSelectedChange,onActiveSpaceChange, spaceNameLabel, buildingOptions, isCreate, selectedBuildingOption,onBuildingChange,onSpaceIdChange, newSpaceId,buildingName,onUploadImageChange, spaceId,activeSpace, availableForEvents, availableForAVEquipment, availableForCatering, availableForHearingAids, availableForPresentationAids, availableForArrivalLocation, onArrivalLocationChange, onAvailableForEventsChange, onAvailableForAVEquipmentChange, onAvailableForPresentationAidsChange, onAvailableForHearingAidsChange, onAvailableForCateringChange, spaceName, onSpaceNameChange,onSpaceCustomInfoChange,spaceCustomInfo, onOrderPolicyChange,allBookingPolicies,selectedPolicy,images,imageUrl} = this.props;
    return (
        <Grid xs={4} pr={2}>
            <Box className="tablePanel">
            {isCreate ?
                <Box sx={{'& > :not(style)': { my: 1}}}>
                    <IbssInputDropDown 
                        value={selectedBuildingOption}
                        inputLabel={this.labels.HubLabelBuilding}
                        required
                        id="Building"
                        error={selectedBuildingOptionError}
                        options={buildingOptions}
                        onChange={e => onBuildingChange(e)}
                    />
                    <IbssTextField 
                        fullWidth
                        required
                        label={this.labels.HubLabelSpaceId}
                        value={newSpaceId}
                        error={spaceIdError}
                        variant="outlined" 
                        onChange={(event: React.ChangeEvent<HTMLInputElement>)=> onSpaceIdChange(event)}
                    />
                </Box>
                :                
                <Box sx={{'& > :not(style)': { my: 2}}}>
                    <IbssPageHeader
                        title={this.labels.HubLabelSpaceConfig}
                        description={this.labels.HubLabelSpaceConfiguration_Message}
                    />
                    <Box mt={2} alignItems={'center'} className="card-secondary d-flex justify-content-between">
                        <Box display={'flex'} alignItems={'center'}>
                            <IbssSvgIcon sx={{color: (theme) => theme.palette.text.secondary }} fontSize='large'>
                                {Icons.SpaceBuildingIcon}
                            </IbssSvgIcon>
                            <Typography ml={2} variant="body1">{this.labels.HubLabelBuilding}</Typography>
                        </Box>
                        <Typography variant="body1">{buildingName}</Typography>
                    </Box>
                    <Box mt={2} alignItems={'center'} className="card-secondary d-flex justify-content-between">
                        <Box display={'flex'} alignItems={'center'}>
                            <IbssSvgIcon sx={{color: (theme) => theme.palette.text.secondary }} fontSize='large'>
                                {Icons.KeyIcon}
                            </IbssSvgIcon>
                            <Typography ml={2} variant="body1">{this.labels.HubLabelSpaceId}</Typography>
                        </Box>
                        <Typography variant="body1">{spaceId}</Typography>
                    </Box>
                </Box>
            }
                <Box className="d-flex justify-content-between" alignItems={'center'} mt={3}>
                <Typography variant="body2">{this.labels.HubLabelActiveSpace}</Typography>
                <IbssFormControl>
                    <IbssSwitchLabel 
                        checked={activeSpace} 
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => onActiveSpaceChange(e)} 
                    />
                </IbssFormControl>
                </Box>

                <Typography variant='body1' mt={3}>{this.labels.funcSpaceCharateristics_S}</Typography>
                <Box className="d-flex justify-content-between" alignItems={'center'}>
                    <Typography variant="body2">{this.labels.funcSpacesAVEquipment_S}</Typography>
                    <IbssFormControl>
                        <IbssSwitchLabel 
                            checked={availableForAVEquipment} 
                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => onAvailableForAVEquipmentChange(e)} 
                        />
                    </IbssFormControl>
                </Box>
                <Box className="d-flex justify-content-between" alignItems={'center'}>
                    <Typography variant="body2">{this.labels.HubLabelPresentationAid}</Typography>
                    <IbssFormControl>
                        <IbssSwitchLabel 
                            checked={availableForPresentationAids} 
                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => onAvailableForPresentationAidsChange(e)} 
                        />
                    </IbssFormControl>
                </Box>
                <Box className="d-flex justify-content-between" alignItems={'center'}>
                    <Typography variant="body2">{this.labels.HubLabelHearingAid}</Typography>
                    <IbssFormControl>
                        <IbssSwitchLabel 
                            checked={availableForHearingAids} 
                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => onAvailableForHearingAidsChange(e)} 
                        />
                    </IbssFormControl>
                </Box>
                <Box className="d-flex justify-content-between" alignItems={'center'}>
                    <Typography variant="body2">{this.labels.funcCatering_S}</Typography>
                    <IbssFormControl>
                        <IbssSwitchLabel 
                            checked={availableForCatering} 
                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => onAvailableForCateringChange(e)} 
                        />
                    </IbssFormControl>
                </Box>
                <Box className="d-flex justify-content-between" alignItems={'center'}>
                    <Typography variant="body2">{this.labels.funcSpaceAvailableForEvents_S}</Typography>
                    <IbssFormControl>
                        <IbssSwitchLabel 
                            checked={availableForEvents} 
                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => onAvailableForEventsChange(e)} 
                        />
                    </IbssFormControl>
                </Box>
                <Box className="d-flex justify-content-between" alignItems={'center'} mb={3}>
                    <Typography variant="body2">{this.labels.funcArrivalLocation_L}</Typography>
                    <IbssFormControl>
                        <IbssSwitchLabel 
                            checked={availableForArrivalLocation} 
                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => onArrivalLocationChange(e)} 
                        />
                    </IbssFormControl>
                </Box>

                <Box sx={{'& > :not(style)': { my:1},}}>
                    <IbssTextField 
                        fullWidth
                        required
                        label={this.labels.HubLabelName}
                        error={spaceNameError}
                        value={spaceName}
                        variant="outlined" 
                        onChange={(event: React.ChangeEvent<HTMLInputElement>)=> onSpaceNameChange(event)}
                    />
                    <IbssTextField 
                        fullWidth
                        required
                        error={spaceNameLabelError}
                        label={this.labels.HubLabelSpaceNameLabel}
                        value={spaceNameLabel}
                        variant="outlined" 
                        onChange={(event: React.ChangeEvent<HTMLInputElement>)=> onSpaceNameLabelChange(event)}
                    />
                    <IbssTextField
                        onChange={(event: React.ChangeEvent<HTMLInputElement>) => onSpaceCustomInfoChange(event)}
                        label={this.labels.HubLabelSpaceCustomInformation}
                        value={spaceCustomInfo}
                        multiline
                        fullWidth
                        rows={4}
                    />
                    <IbssInputDropDown
                        onChange={e => onOrderPolicyChange(e)}
                        value={selectedPolicy}
                        required
                        inputLabel={this.labels.HubBookingPolicyTitle}
                        error={bookingPolicyOptionError}
                        id="Booking Policy"
                        disabled={selectedBuildingOption == "" && isCreate}
                        options={allBookingPolicies}
                    />
                    <Box>
                        <Typography variant="body1">
                            {this.labels.HubLabelSpaceImage}
                        </Typography>
                        <MediaSelector
                            options={images.map(x => {return{name: x.name, url:x.path}})}
                            imageSelected={(file: IFileType) => imageSelectedChange(file)}
                            uploadFile={(filename: string, file: FormData, processAsMap: boolean) => onUploadImageChange(filename, file, processAsMap)}
                            defaultSelectedImage={imageUrl}
                        />
                    </Box>
                </Box>
            </Box>
        </Grid>
    )
  }
}

interface ISpaceConfigurationProps 
{
    buildingName: string;
    spaceId: string;
    activeSpace: boolean;
    availableForEvents: boolean;
    availableForAVEquipment: boolean;
    availableForCatering: boolean;
    availableForHearingAids: boolean;
    availableForPresentationAids: boolean;
    availableForArrivalLocation: boolean;
    spaceName: string;
    onSpaceNameChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    onSpaceCustomInfoChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    spaceCustomInfo: string;
    onOrderPolicyChange: (event: SelectChangeEvent) => void;
    selectedPolicy: string;
    allBookingPolicies: IFilterOptions[];
    images: IFile[];
    onActiveSpaceChange:  (event: React.ChangeEvent<HTMLInputElement>) => void;
    onAvailableForEventsChange:  (event: React.ChangeEvent<HTMLInputElement>) => void;
    onAvailableForAVEquipmentChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    onAvailableForCateringChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    onAvailableForHearingAidsChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    onAvailableForPresentationAidsChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    onArrivalLocationChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    onUploadImageChange: (filename: string, file: FormData, processAsMap: boolean) => Promise<void>;
    imageUrl: string;
    getImages: () => void;
    buildingOptions: IFilterOptionsNumber[];
    selectedBuildingOption: string;
    onBuildingChange: (event: SelectChangeEvent) => void;
    newSpaceId: string;
    onSpaceIdChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    spaceNameLabel: string;
    onSpaceNameLabelChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    isCreate: boolean;
    imageSelectedChange: (file: IFileType) => void;
    spaceNameError: boolean;
    selectedBuildingOptionError: boolean;
    bookingPolicyOptionError: boolean;
    spaceIdError: boolean;
    spaceNameLabelError:boolean;   
}